import grading from '@/api/grading-definition'
import { baseState, baseMutations } from '@/store/mixins'
import subProgram from '@/api/sub-program'

export const state = {
  ...baseState,
  main_programs: [],
  edit_data: {}
}

export const getters = {}

export const mutations = {
  ...baseMutations,
  SET_MAIN_PROGRAMS (state, data) {
    state.main_programs = data
  },
  SET_EDIT_DATA (state, data) {
    state.edit_data = data
  }
}

export const actions = {
  fetch (context, attributes = {}) {
    const params = Object.assign(
      {
        page: context.state.pagination.page,
        perPage: context.state.pagination.perPage,
        search: context.state.search
      },
      attributes
    )

    return grading.get({ params }).then(response => {
      context.commit('RECEIVE_RESOURCES', response)
      return Promise.resolve(response)
    })
  },
  store (context, data) {
    return grading.store(data)
  },
  copy (context, data) {
    return grading.copy(data)
  },

  async find (context, id) {
    if (_.isEmpty(context.state.edit_data)) {
      let response = await grading.find(id)
      context.commit('SET_EDIT_DATA', response.data)
    }
  },

  update (context, data) {
    return grading.update(data)
  },

  async dataBeforeCreate (context) {
    if (!context.state.main_programs.length > 0) {
      let response = await grading.mainProgram()
      context.commit('SET_MAIN_PROGRAMS', response)
    }
  },
  getSubProgram (context, attributes = {}) {
    return subProgram.get({
      params: {
        fields: {
          academic_program_subs: 'acp_id,acps_id,acps_name_foreign'
        },
        page: -1
      },
      headers: {
        'X-PERMISSION-ALLOW-CODE': context.rootGetters.permissionAllowCode
      }
    })
  }
}
